var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.work)?_c('div',_vm._l((_vm.work.decisions),function(decision){return _c('div',{key:decision.id},[_c('p',[_vm._v(" "+_vm._s(decision.answer))]),_c('small',[_vm._v(" "+_vm._s(decision.comment))])])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }